<template>
  <boxwrap class="domains--inner">
    <toolbar>
      <toolbar-items
        class="-buttons"
        v-if="checkPermission"
      >
      </toolbar-items>

      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          @click="deleteData()"
          v-if="selected.length > 0 &&
            $route.params.status === 'inactive'"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          @click="restore(selected)"
          v-if="selected.length > 0 &&
            $route.params.status === 'deleted'"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--modify"
          title="modify"
          @click="update(selected, domainList)"
          v-if="selected.length > 0 &&
            $route.params.status !== 'deleted'"
        >
          <i class="ico--save"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents
      :class="[showDataLoading ? 'data-loading' : '']"
    >
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input type="checkbox" @change="checkAll(domainList)">
                </checkbox>
              </tbl-td>
              <tbl-td
                name="id"
                :sort="true"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                no
              </tbl-td>
              <tbl-td
                name="created-at"
                :sort="true"
                v-if="checkCol('created_at', tblSetting)"
                @click.native="sort('created_at')"
              >
                created at
              </tbl-td>
              <tbl-td
                name="name"
                :sort="true"
                v-if="checkCol('name', tblSetting)"
                @click.native="sort('name')"
              >
                name
              </tbl-td>
              <tbl-td
                name="status"
                :sort="true"
                v-if="checkCol('active', tblSetting)"
                @click.native="sort('active')"
              >
                status
              </tbl-td>
              <tbl-td
                name="memo"
                :sort="true"
                v-if="checkCol('memo', tblSetting)"
                @click.native="sort('memo')"
              >
                memo
              </tbl-td>
              <tbl-td
                name="updated-at"
                :sort="true"
                v-if="checkCol('updated_at', tblSetting)"
                @click.native="sort('updated_at')"
              >
                updated at
              </tbl-td>
              <tbl-td
                name="deleted-at"
                :sort="true"
                v-if="checkCol('deleted_at', tblSetting)"
                @click.native="sort('deleted_at')"
              >
                deleted at
              </tbl-td>
              <tbl-td
                name="delete-restore"
                v-if="checkPermission &&
                  ($route.params.status === 'inactive' ||
                  $route.params.status === 'deleted')"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>
          <tbl-body>
            <tbl-row
              v-for="(item, index) in domainList"
              :key="index"
              @click.native="showUpdateForm(item)"
              :class="{'is-deleted': item.deleted_at}"
            >
              <tbl-td
                name="checkbox"
                @click.native.stop
              >
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="item.id"
                  >
                </checkbox>
              </tbl-td>
              <tbl-td
                name="id"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(index, query.page, query.rows, query.sort, count || 0) }}
              </tbl-td>
              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ item.created_at | date }}
              </tbl-td>
              <tbl-td
                name="name"
                v-if="checkCol('name', tblSetting)"
              >
                {{ item.name }}
              </tbl-td>
              <tbl-td
                name="status"
                v-if="checkCol('active', tblSetting)"
              >
                <!-- {{ formatStatus(item.active) }} -->
                <select-list
                  :title="item.active ? 'active' : 'inactive'"
                  :withReset="true"
                  v-model="item.active"
                  v-if="checkPermission"
                  @reset="resetTrigger(item)"
                >
                  <select-option
                    name="active"
                    :value="true"
                    v-if="!item.active"
                    @click.native="setSelected(item)"
                  >
                    active
                  </select-option>
                  <select-option
                    name="inactive"
                    :value="false"
                    v-if="item.active"
                    @click.native="setSelected(item)"
                  >
                    inactive
                  </select-option>
                </select-list>
              </tbl-td>
              <tbl-td
                name="memo"
                v-if="checkCol('memo', tblSetting)"
              >
                {{ item.memo }}
              </tbl-td>
              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ item.updated_at | date }}
              </tbl-td>
              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ item.deleted_at | date }}
              </tbl-td>
              <tbl-td
                name="delete-restore"
                v-if="checkPermission &&
                  ($route.params.status === 'inactive' ||
                  $route.params.status === 'deleted')"
              >
                <button
                  class="btn--restore"
                  v-if="item.deleted_at"
                  @click.exact="restore(item.id)"
                  @click.stop=""
                >
                  <i class="ico--restore"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
        <tbl-footer>
          <pagination
            :total="count"
            v-model="query.page"
            :rows="query.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-domain"
      title="create domain"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event, resetModal('modify')"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>Domain Name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-validate="'required'"
                  v-model="domainModel.name"
                >
                <span v-if="errors.has('form-entry.domain_name')">
                  {{ errors.first('form-entry.domain_name') }}
                </span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Status</span></div>
            <div class="form-data">
              <select-list
                :title="domainModel.active | status"
                :withReset="true"
                v-model="domainModel.active"
              >
                <select-option value="1" name="active">active</select-option>
                <select-option value="0" name="inactive">inactive</select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Memo</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <text-area
                name="memo"
                v-validate="'required'"
                v-model="domainModel.memo"
                ></text-area>
              </div>

              <span v-if="errors.has('form-entry.memo')">
                {{ errors.first('form-entry.memo') }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--update-domain"
      title="modify domain"
      v-if="showUpdate"
      :activate="showUpdate"
      @activate="showUpdate = $event, resetModal('modify')"
    >
      <template slot="body">
        <div class="form-con">
          <div class="form-items">
            <div class="form-lbl"><span>created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ domainUpdateModel.created_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>updated at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ domainUpdateModel.updated_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ domainUpdateModel.deleted_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Domain Name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input
                  type="text"
                  v-validate="'required'"
                  v-model="domainUpdateModel.name"
                >
                <span v-if="errors.has('form-entry.domain_name')">
                  {{ errors.first('form-entry.domain_name') }}
                </span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Status</span></div>
            <div class="form-data">
              <select-list
                :title="domainUpdateModel.active | status"
                :withReset="true"
                v-model="domainUpdateModel.active"
              >
                <select-option value="1" name="active">active</select-option>
                <select-option value="0" name="inactive">inactive</select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl -content"><span>Memo</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <text-area
                  name="memo"
                  v-validate="'required'"
                  v-model="domainUpdateModel.memo"
                  :content="domainUpdateModel.memo"
                ></text-area>
              </div>
              <span v-if="errors.has('form-entry.memo')">
                {{ errors.first('form-entry.memo') }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="update()"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'

import { checkAll } from '@/assets/js/mixins/base/CheckAll'
import { swal } from '@/assets/js/mixins/base/Swal'

import Modal from '@/components/base/Modal'
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import TextArea from '@/components/base/TextArea'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

export default {
  name: 'domains',
  components: {
    Pagination,
    Modal,
    Checkbox,
    Search,
    CheckDataList,
    TextArea
  },

  mixins: [ checkAll, swal ],

  filters: {
    status (val) {
      if (val === 1) {
        return 'active'
      }
      return 'inactive'
    }
  },

  data () {
    let query = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      query,
      searchInput: '',
      editFormVisible: false,
      totalDataFetch: 0,
      selected: [],
      selectAll: false,
      domainList: [],
      domainModel: this.getDefaultModel(),
      domainUpdateModel: this.getDefaultUpdateModel(),
      status: 'all',
      filterBy: [
        { value: 'name', display: 'Name' },
        { value: 'memo', display: 'Memo'}
      ],
      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      showCreate: false,
      showUpdate: false,

      showTblSettings: false,

      tblSetting: 'domains',

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      allCols: [
        {
          display: 'no',
          value: 'id'
        },

        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'name',
          value: 'name'
        },
        {
          display: 'active',
          value: 'active'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        },
        {
          display: 'memo',
          value: 'memo'
        }
      ]
    }
  },

  computed: {
    ...mapState('domain', [ 'domains', 'count' ]),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    async '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  async created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }

    this.query = this.generate(this.query)
    this.search()
  },

  methods: {
    ...mapActions('domain', [ 'get', 'delete' ]),
    ...mapActions('domain', { createDomain: 'create' }),
    ...mapActions('domain', { updateDomain: 'update' }),
    ...mapActions('domain', { restoreDomain: 'restore' }),

    getDefaultModel () {
      return {
        name: '',
        active: 1,
        memo: ''
      }
    },

    getDefaultUpdateModel () {
      return {
        id: '',
        name: '',
        active: 1,
        memo: ''
      }
    },

    formatStatus (status) {
      return (status) ? 'active' : 'inactive'
    },

    async search (query) {
      this.query = query || this.query
      this.status = this.$route.params.status
      this.selected = []
      this.isEmpty = false

      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        status: this.status,
        params: this.query
      })

      this.isDataLoading = false
      this.showDataLoading = false

      this.domainList = JSON.parse(JSON.stringify(this.domains))

      if (!this.domains.length) {
        this.isEmpty = true
      }
    },

    async create () {
      let success = async () => {
        let result = await this.createDomain(this.domainModel)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created a domain.', {}, '', 'Success')
          this.showCreate = false
          this.domainModel = _.assign(this.domainModel, this.getDefaultModel())
          this.search()
        }
      }

      this.domainModel.active = parseInt(this.domainModel.active, 10)

      if (this.domainModel.name.trim() === '') {
        this.$alert('error', 'Missing Domain Name data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Domain')
    },

    async sortList () {
      this.$router.push({ path: '/domains' })
      this.setRouterQuery(this.query)
    },

    async deleteData () {
      let success = async () => {
        let result = await this.delete({ data: this.selected })

        if (result.status === 202) {
          this.$alert('success', 'You have successfully delete the domain(s).', {}, '', 'Success')
          this.selected = []
          this.selectAll = false
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to delete the following domain(s)?', {}, { success }, 'Delete Domain')
    },

    async showUpdateForm (item) {
      this.domainUpdateModel = Object.assign({}, item)
      this.domainUpdateModel.active = (this.domainUpdateModel.active) ? 1 : 0
      this.showUpdate = true
    },

    async update (selected = [], domainList) {
      let success = async () => {
        let params = []
        let result

        if (!this.domainUpdateModel.id &&
            selected.length > 0) {
          domainList.forEach((data) => {
            selected.forEach((v, k) => {
              if (data.id === v) {
                params.push(Object.assign({}, data, {
                  active: data.active ? 1 : 0
                }))
              }
            })
          })
        } else {
          params.push(Object.assign({}, this.domainUpdateModel, {
            active: parseInt(this.domainUpdateModel.active, 10)
          }))
        }

        result = await this.updateDomain(params)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully modified the domain(s).', {}, '', 'Success')
          this.domainUpdateModel = this.getDefaultUpdateModel()
          this.showUpdate = false
          this.search()
        }
      }

      if (this.domainUpdateModel.id &&
          this.domainUpdateModel.name.trim() === '') {
        this.$alert('error', 'Missing Domain Name data.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to modify this domain?', {}, { success }, 'Modify Domain')
    },

    async trigger (query) {
      this.query = query || this.query
      this.$router.push({ query: this.query })
    },

    async restore (ids) {
      let success = async () => {
        let params = []
        let result

        if (!Array.isArray(ids)) {
          params.push({
            id: ids,
            data: { deleted_at: null }
          })
        } else {
          ids.map((id) => {
            params.push({
              id: id,
              data: { deleted_at: null }
            })
          })
        }

        result = await this.restoreDomain(params)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully restore the domain(s).', {}, '', 'Success')
          this.search()
        }
      }

      this.$alert('prompt', 'Are you sure you want to restore the following domain(s)?', {}, { success }, 'Restore Domain')
    },

    setSelected (data) {
      this.$nextTick(() => {
        let result = this.domains.find((row) => {
          return row.id === data.id
        })

        let idx = this.selected.indexOf(data.id)

        if (data.active === result.active &&
            idx > -1) {
          this.selected.splice(idx, 1)
          return
        }

        if (data.active === result.active) {
          return
        }

        this.selected.push(data.id)
        this.selected = this.selected.filter((val, idx, arr) => {
          return arr.indexOf(val) === idx
        })
      })
    },

    resetTrigger (data) {
      this.$nextTick(() => {
        let count = 0
        let idx = this.selected.indexOf(data.id)

        let result = this.domains.find((row) => {
          return row.id === data.id
        })

        if (result.active !== data.active) {
          count += 1
        }

        if (count === 0 && idx > -1) {
          this.selected.splice(idx, 1)
        }
      })
    },

    resetModal (flag) {
      if (flag === 'create') {
        this.domainModel = this.getDefaultModel()
      } else {
        this.domainUpdateModel = this.getDefaultUpdateModel()
      }
    },

    sort (sortBy) {
      if (this.query.sort === 'asc') {
        this.query.sort = 'desc'
      } else {
        this.query.sort = 'asc'
      }

      this.query.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    }
  }
}
</script>
